'use strict'

import ApiClient from './ApiClient'

export default class ImageRepository {
  /**
   * 画像を取得する
   * @param url
   * @returns {*}
   */
  get (url) {
    return ApiClient().get(url)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/ImageRepository.js